import React, { useState, useEffect } from "react";
import * as vehicleApi from "../../../api/vehicleApi";
import { toast } from "react-toastify";
import { VehiclesForm } from "../../forms/Master/VehiclesForm";
import PropTypes from "prop-types";
import { showDeleteConfirm } from "../../common/ConfirmationModal";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

export default function VehiclesPage({ history }) {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(true);
  const [vehicles, setVehicles] = useState([]);
  const [rowSelected, setRowSelected] = useState({});
  const location = useLocation();
  let defaultPagination = location.state
    ? location.state.currentPage
      ? location.state.currentPage
      : 1
    : 1;
  const [currentPage, setCurrentPage] = useState(defaultPagination);

  useEffect(getVehicles, []);

  function getVehicles() {
    vehicleApi
      .getAllVehicles()
      .then((result) => {
        setIsLoading(false);
        setVehicles(result);
      })
      .catch((error) => {
        setIsLoading(false);
        setVehicles([]);
        showErrorMessage(t("general.fail_to_load_record") + error.message);
      });
  }

  function addNewItem() {
    history("/home/vehicles/vehicle", {
      state: { currentPage: currentPage },
    });
  }

  function editItem(vehicleKey) {
    history("/home/vehicles/vehicle/" + vehicleKey, {
      state: { currentPage: currentPage },
    });
  }

  function onDelete(vehicleKey) {
    showDeleteConfirm("Vehicle", vehicleKey, deleteVehicle, t);
  }

  function deleteVehicle(vehicleKey) {
    setIsLoading(true);
    vehicleApi
      .deleteVehicle(vehicleKey)
      .then(() => {
        const newData = vehicles.filter(
          (item) => item.VehicleKey !== vehicleKey
        );
        setVehicles(newData);
        setIsLoading(false);
        toast.success(t("general.record_deleted_successfully"));
      })
      .catch((error) => {
        setIsLoading(false);
        showErrorMessage(t("general.fail_to_delete_record") + error.message);
      });
  }

  function showErrorMessage(message) {
    toast.error(message);
  }

  function onRowSelected(value) {
    if (value.UpdatedDate) {
      value.UpdatedOn = value.UpdatedDate;
    }
    if (value.CreatedDate) {
      value.CreatedOn = value.CreatedDate;
    }
    setRowSelected(value);
  }

  return (
    <VehiclesForm
      isLoading={isLoading}
      vehicles={vehicles}
      onAdd={addNewItem}
      onEdit={editItem}
      onDelete={onDelete}
      onRowSelected={onRowSelected}
      rowSelected={rowSelected}
      setCurrentPage={setCurrentPage}
      currentPage={currentPage}
    />
  );
}

VehiclesPage.propTypes = {
  history: PropTypes.func.isRequired,
};
